import { clearUser } from "@Pages/Profile/profileSlice";
import { Tokens } from "../constants/common";
import { AppDispatch, RootState, useAppSelector } from "../store/store";
import { clearIgSelection } from "../store/igSelectionSlice";

import { useOutletContext } from "react-router-dom";

import { baseApi } from "@Services/api";
import posthog from "posthog-js";

export const onLogout = async (dispatch: AppDispatch, isManualLogout: boolean = false) => {

  let params = {}
  if (isManualLogout) {
    params = AnalyticsParamBuilder({
      phylum: 'manual',
    })

    posthog.capture("user_logout", params);
    posthog.reset()
  } else {
    params = AnalyticsParamBuilder({
      phylum: 'auto',
    })
  }


  localStorage.removeItem("access_token"); // or Tokens.ACCESS_TOKEN
  localStorage.removeItem("refresh_token"); // or Tokens.REFRESH_TOKEN

  dispatch(clearUser()); // Reset user state
  dispatch(clearIgSelection()); // Clear IG selection
  dispatch(baseApi.util.resetApiState()); // Reset RTK Query cache
};

export const formatTimestampDifference = (timestampString: string) => {
  // Convert timestamp string to a Date object
  const timestamp = new Date(timestampString);

  // Get the current time in milliseconds
  const currentTime = new Date().getTime();

  // Calculate the time difference in milliseconds
  const timeDifference = currentTime - timestamp.getTime();

  // Function to convert milliseconds to hours
  const millisecondsToHours = (ms: number) => {
    return ms / (1000 * 60 * 60);
  };

  // Function to convert milliseconds to days
  const millisecondsToDays = (ms: number) => {
    return ms / (1000 * 60 * 60 * 24);
  };

  // Function to convert milliseconds to months
  const millisecondsToMonths = (ms: number) => {
    return ms / (1000 * 60 * 60 * 24 * 30); // Approximation
  };

  // Format the time difference based on the duration
  const formatTimeDifference = (difference: number) => {
    if (difference < 1) {
      return "Just now";
    } else if (difference < 24) {
      return `${Math.floor(difference)} hours ago`;
    } else if (difference < 30) {
      return `${Math.floor(difference / 24)} days ago`;
    } else {
      const formattedDate = timestamp.toLocaleDateString("en-GB");
      return formattedDate;
    }
  };

  // Calculate the difference in hours, days, and months
  const differenceInHours = millisecondsToHours(timeDifference);
  const differenceInDays = millisecondsToDays(timeDifference);
  const differenceInMonths = millisecondsToMonths(timeDifference);

  // Format the time difference
  const formattedTimeDifference = formatTimeDifference(differenceInHours);

  return formattedTimeDifference;
};

export const getReferralIdFromCookie = () => {
  const name = "lprefid=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    let c = cookies[i].trim();
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return null;
};

export const validateUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const getUtmParamsFromCookies = (): { [key: string]: string } => {
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split(";");
  const utmParams: { [key: string]: string } = {};

  cookies.forEach((cookie) => {
    const [key, value] = cookie.trim().split("=");
    if (key.toLowerCase().startsWith("utm_")) {
      utmParams[key.toLowerCase()] = value;
    }
  });

  return utmParams;
};

export const deleteUTMCookies = () => {
  const cookies = document.cookie.split(";");
  const currentHost = window.location.hostname;
  const isLocalhost =
    currentHost === "localhost" || currentHost === "127.0.0.1";
  const COOKIE_PATH = "/";
  const COOKIE_DOMAIN = isLocalhost ? "" : ".linkplease.co";

  cookies.forEach((cookie) => {
    const [rawName] = cookie.split("=");
    const name = rawName.trim();

    if (name.startsWith("utm_")) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${COOKIE_PATH}${COOKIE_DOMAIN ? `; domain=${COOKIE_DOMAIN}` : ""
        }; SameSite=Lax`;
    }
  });

  console.log("UTM values removed");
};

export const CheckPasswordStrength = (password: string) => {
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumbers = /\d/.test(password);
  const hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  if (
    password.length >= minLength &&
    hasUpperCase &&
    hasLowerCase &&
    hasNumbers &&
    hasSpecialChars
  ) {
    return true;
  } else {
    return false;
  }
};

export const textToBytes = (data: string) => {
  const encoder = new TextEncoder(); // UTF-8 by default
  const encoded = encoder.encode(data);
  return encoded;
};

export const formatNumber = (num?: number) => {
  if (num === undefined || num === null) return "0";
  if (num >= 1_000_000)
    return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  return num.toString();
};

export const useUpgradeContext = () => {
  return useOutletContext<{
    setUpgradeToPro: React.Dispatch<React.SetStateAction<boolean>>;
  }>();
};

export function getCookie(name: string) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}

export const AnalyticsParamBuilder = (
  params: {
    kingdom?: any;
    phylum?: any;
    classValue?: any;
    genus?: any;
    family?: any;
    int_value?: any;
    float_value?: any;
    str_value?: any;
  } = {}
) => {
  return {
    kingdom: params?.kingdom,
    phylum: params?.phylum,
    class: params?.classValue,
    genus: params?.genus,
    family: params?.family,
    int_value: params?.int_value,
    float_value: params?.float_value,
    str_value: params?.str_value,
  };
};


export const OnTextBlurAnalytics = (component: string, input_component: string, text: string, type: string) => {
  posthog.capture("ui_input", AnalyticsParamBuilder({
    kingdom: component,
    phylum: input_component,
    classValue: type,
    str_value: text,
  }));
}




export const clientId = "1018531886387218";
export const redirectPath = "/connect/ig";
export const responseType = "code";
export const scope = "instagram_business_basic,instagram_business_manage_comments,instagram_business_manage_messages,instagram_business_content_publish";